// extracted by mini-css-extract-plugin
export default {"root":"F6pROFctxsLyoaHYTauE","cross":"u9XQHYO176uLfRqo5CXA"};